module.exports = __webpack_public_path__ + "static/media/homeLocation.svg";